import { useAppSelector } from 'redux/store/store.types';

import css from '../nibTable.module.sass';

const ThumbnailCell = ({ value: initialValue, row: { index, original }, column: { id }, data = {} }) => {
  const { isNewMedia } = useAppSelector((store) => store.media);
  const onClick = () => {
    if (data.onClick) {
      data.onClick(original);
    }
  };

  return (
    <div className={css.thumbnailCell} onClick={onClick}>
      <img
        src={isNewMedia ? initialValue : process.env.REACT_APP_API_URL + initialValue}
        alt=""
        height="45"
        width="auto"
      />
    </div>
  );
};

export default ThumbnailCell;
